import { getId } from '../../util/data';
import { Loading } from '../../util/decorators';
import { omit } from '../../util/object';
import { apiBannerAdd, apiBannerDelete, apiBannerGet, apiBannerUpdate, apiFileUpload, type Banner } from '../api';

export const isEdit = (record: unknown) => Boolean(record && (<any>record).isEdit);

export interface IDataSource extends Banner {
  isEdit?: boolean;
}

export class BannerService {
  dataSource: IDataSource[] = [];

  dataSourceLoading = false;

  @Loading<BannerService>(['dataSourceLoading'])
  async requestDataSource() {
    const { data } = await apiBannerGet();
    this.dataSource = data;
  }

  add() {
    this.dataSource.unshift({ isEdit: true, id: getId(), } as IDataSource);
  }

  async upsert(record: IDataSource, file?: Blob) {
    if (file) {
      const { data } = await apiFileUpload(file);
      record.image = data;
    }
    if (record.id >= 0) {
      await apiBannerUpdate(record);
    } else {
      await apiBannerAdd(omit(record, ['id']));
    }
  }

  async del(id: IDataSource['id']) {
    if (id >= 0) await apiBannerDelete(id);
    this.dataSource.splice(this.dataSource.findIndex(_ => _.id === id), 1);
  }
}

export const bannerService = new BannerService();
